<template>
	<div class="subject-audit-list">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right">
										<Breadcrumb />
									</div>
									<h3 class="header-title mb-3">
										课题申报
										<span class="ml-2">（本轮申报截止：{{ declareEndTime }}）</span>
									</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">

										<div class="topic_list" v-if="!isShowDetail">
											<el-form ref="form" :model="form" label-width="60px">
												<el-row :gutter="20">
													<el-col :span="6">
														<el-form-item label="关键词">
															<el-input v-model="form.keyWords"></el-input>
														</el-form-item>
													</el-col>
													<el-col :span="6">
														<el-button type="primary" @click="search">搜索</el-button>
														<el-button type="primary" @click="goTopicsDeclaration">申报新课题
														</el-button>
														<!-- <el-popover style="margin-left: 20px;" v-else placement="top-start" title="提示" width="200" trigger="click" content="本次申报已截止">
															<el-button slot="reference" type="primary">申报新课题</el-button>
														</el-popover> -->
													</el-col>
												</el-row>
											</el-form>

											<el-table :header-cell-style="tableStyle" :data="topicList" border
												style="width: 100%">
												<el-table-column label="序号" type="index" width="50"></el-table-column>
												<el-table-column prop="name" label="课题名称" width="180">
													<template v-slot="scope">
														<div style="color: deepskyblue;cursor: pointer;"
															@click="viewTopicDetail(scope.row)">{{scope.row.name}}</div>
													</template>
												</el-table-column>
												<el-table-column prop="oneEmceeName" label="负责人" width="65">
												</el-table-column>
												<el-table-column prop="createTime" label="申报时间" width="80">
													<template slot-scope="scope">
														{{ scope.row.createTime | getTime }}
													</template>
												</el-table-column>
												<el-table-column prop="learningTypeName" label="所属学段" width="80">
												</el-table-column>
												<el-table-column prop="disciplineName" label="学科" width="60">
												</el-table-column>
												<!-- <el-table-column prop="projectTypeName" label="课题类别" width="80"></el-table-column> -->
												<el-table-column prop="type" label="审核进度" width="320">
													<template slot-scope="scope">
														<ReviewProgress :status="scope.row.type"></ReviewProgress>
													</template>
												</el-table-column>
												<el-table-column label="操作">
													<template slot-scope="scope">
														<el-button-group>
															<el-button size="mini" type="primary" v-if="[0, 1, 2, 5].includes(scope.row.type)"	@click="editTopic(scope.row.id)">修改</el-button>
															<el-popconfirm title="确定删除吗？" @confirm="confirmDel(scope.row.id)">
																<el-button slot="reference" size="mini" type="danger" v-if="isShowDelBtn(scope.row)">删除</el-button>
															</el-popconfirm>
															<el-button size="mini" type="success" v-if="scope.row.type == 23">下载</el-button>
															<el-button size="mini" type="primary" v-if="scope.row.type >= 2" @click="viewReviewOpinion(scope.row.id)">审核意见</el-button>
														</el-button-group>
													</template>
												</el-table-column>
											</el-table>

											<!-- 分页器 -->
											<div style="text-align: center;margin-top: 20px;">
												<el-pagination @size-change="handleSizeChange"
													@current-change="handleCurrentChange"
													:current-page="form.pageNumber" :page-sizes="[10, 20, 50]"
													:page-size="form.pageSize"
													layout="total, sizes, prev, pager, next, jumper" :total="total">
												</el-pagination>
											</div>
										</div>

										<div class="card-reviewDetails" v-else>
											<h3 class="text-center">{{ topicInfo.name }}</h3>
											<div class="row row-reviewDetails">
												<div class="col-6 col-md-3">负责人姓名：{{ getAllEmcee }}</div>
												<div class="col-6 col-md-3">申报单位：{{ topicInfo.unitName }}</div>
												<div class="col-6 col-md-3">学段：{{ topicInfo.learningTypeName }}</div>
												<div class="col-6 col-md-3">领域：{{ topicInfo.researchFieName }}</div>
												<div class="col-6 col-md-3">
													预结题时间：{{ topicInfo.expectedClosingTime | getTime }}</div>
												<div class="col-6 col-md-3">学科：{{ topicInfo.disciplineName }}</div>
												<div class="col-6 col-md-3">
													专业技术职务：{{ topicInfo.professionalSkillPostName }}</div>
												<div class="col-6 col-md-3">学历：{{ topicInfo.lastDegreeId }}</div>
												<div class="col-6 col-md-3">学位：{{ topicInfo.lastQualificationId }}</div>
												<div class="col-6 col-md-3">研究专长：{{ topicInfo.areasSpecialization }}
												</div>
												<div class="col-6 col-md-3">出生日期：{{ topicInfo.birthTime | getTime }}
												</div>
												<div class="col-6 col-md-3">行政职务：{{ topicInfo.administrativeDuties }}
												</div>
												<div class="col-12">核心成员：{{ topicInfo.coreMember | getMember }}</div>
											</div>
											<!-- 审核文件列表 -->
											<ul class="file-list">
												<li class="file-item" :class="{ active: curFileTitleIndex === index }"
													v-for="(item, index) in fileTitleList" :key="index"
													@click="changeFileTitle(index)">
													{{ item }}
												</li>
											</ul>

											<!-- 在线浏览文档 -->
											<div class="view"><iframe ref="myIframe" height="100%"
													width="100%"></iframe></div>

											<!-- 审核意见列表 -->
											<div class="comments-list" v-if="topicInfo.schoolAuditList">
												<div class="form-group row mb-2"
													v-for="(item, index) in topicInfo.schoolAuditList" :key="index">
													<label class="col-md-2 col-12 col-form-label"
														style="text-align: right;">
														{{ item.auditType == 1 ? '区级审核' + (index + 1) : '学校审核' + (index + 1) }}
													</label>
													<div class="col-md-9 col-10">
														<table class="table table-bordered table-centered mb-0">
															<tbody>
																<tr>
																	<th>审核意见</th>
																	<td>{{ item.auditState == 2 ? '不通过' : item.auditState == 1 ? '通过' : '退回修改' }}
																	</td>
																	<th>审核人</th>
																	<td>{{ item.auditName }}</td>
																	<th>审核时间</th>
																	<td>{{ item.createTime | getTime }}</td>
																</tr>
																<tr>
																	<th>审核说明</th>
																	<td colspan="5">{{ item.auditExplain }}</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div class="col-md-1 col-2"><span class="required"></span></div>
												</div>
											</div>

											<div class="btn_wrap">
												<el-button type="primary" @click="isShowDetail=false">返回</el-button>
											</div>
											<!-- 表单 -->
											<!-- <el-form :model="auditForm" :rules="auditFormRules" ref="auditFormRef" label-width="100px">
												<el-form-item label="审核意见" prop="auditState">
													<el-radio-group v-model="auditForm.auditState">
														<el-radio :disabled="isOverTime" :label="0">退回修改</el-radio>
														<el-radio :disabled="isOverTime" :label="1">通过</el-radio>
														<el-radio :label="2">不通过</el-radio>
													</el-radio-group>
												</el-form-item>
												<el-form-item label="审核说明" prop="auditExplain"><el-input v-model="auditForm.auditExplain" type="textarea" autosize></el-input></el-form-item>
											</el-form> -->

											<!-- <div class="text-center">
												<button type="button" class="btn btn-info" @click="submitAudit">确定</button>
												<button type="button" class="btn btn-light" style="margin-left: 20px;" @click="goBack">关 闭</button>
											</div> -->
										</div>

									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
	import ReviewProgress from '@/views/backstage/components/ReviewProgress.vue';
	import {
		getTopicsDeclarationList,
		delTopicsDeclaration,
		topicDeclareBtnRightControl
	} from '@/api/after/projectApplication.js';
	import {
		TopicDeclarationDetail
	} from '@/api/after/schoolAudit.js';
	import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
	export default {
		components: {
			ReviewProgress,
			Breadcrumb
		},
		data() {
			return {
				isShowDetail: false, //是否显示课题审核详情
				tableStyle: {
					backgroundColor: '#7e9be2',
					color: '#fff',
					textAlign: 'center'
				},
				projectData: {},
				form: {
					keyWords: '',
					pageNumber: 1,
					pageSize: 10,
					projectId: 0
				},
				total: 0,
				topicList: [],
				declareEndTime: '', //申报截止日期
				userinfo: JSON.parse(sessionStorage.getItem('userInfo')),
				topicInfo: {},
				curFileTitleIndex: 0,
				fileTitleList: ['课题申请书', '匿名评审活页'],
			};
		},
		filters: {
			
			getMember(val) {
				if (val) {
					return val.replace(/,/g, '、')
				}
			},
		},
		computed: {
			getAllEmcee() {
				if (Object.keys(this.topicInfo).length) {
					if (this.topicInfo.twoEmceeName) {
						return `${this.topicInfo.oneEmceeName}、${this.topicInfo.twoEmceeName}`
					} else {
						return this.topicInfo.oneEmceeName
					}
				}
			}
		},
		created() {
			this.projectData = JSON.parse(sessionStorage.getItem('projectData') || '{}');
			console.log('项目数据', this.projectData);
			if (Object.keys(this.projectData).length) {
				// 如果没有匿名评审页,那么只渲染课题申请书
				if (this.projectData.anonymousReviewState == 0) {
					this.fileTitleList = ['课题申请书']
				}
				this.form.projectId = this.projectData.id;
				this.declareEndTime = this.projectData.declareEndTime;
				this.getTopicsDeclarationList();
			}
		},
		methods: {
			// 控制删除按钮的显示和隐藏
			isShowDelBtn(data) {
				let declareEndTime = JSON.parse(sessionStorage.getItem('projectData')).declareEndTime
				return ([0, 1, 3, 6, 24].includes(data.type) && new Date(declareEndTime).getTime() > Date.now())
			},
			// 改变文件标题索引
			changeFileTitle(index) {
				this.curFileTitleIndex = index
				if (index == 0) {
					this.$refs.myIframe.contentWindow.location.replace(
						`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`)
				} else {
					this.$refs.myIframe.contentWindow.location.replace(
						`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.anonymousReview}`)
				}
			},
			// 课题申报详情
			async TopicDeclarationDetail(id) {
				const res = await TopicDeclarationDetail(id)
				if (res.code == 200) {
					console.log('详情', res);
					this.topicInfo = res.data
					this.$nextTick(() => {
						// 数据请求成功之后渲染pdf
						if (Object.keys(this.topicInfo).length) {
							this.$refs.myIframe.contentWindow.location.replace(
								`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`
							)
						}
					})
				} else {
					this.$message.error(res.data)
				}
			},
			// 点击课题名称查看详情
			viewTopicDetail(data) {
				this.TopicDeclarationDetail(data.id)
				this.isShowDetail = true
			},
			// 查看审核意见
			viewReviewOpinion(id) {
				this.$router.push('/backstage/reviewOpinion?id=' + id);
			},
			// 编辑课题
			editTopic(id) {
				let query = {
					projectId: this.projectData.id,
					limit: this.projectData.limit,
					topicId: id
				};
				this.$router.push({
					path: '/backstage/projectApplicationProcess',
					query
				});
			},
			// 删除课题
			async confirmDel(id) {
				const res = await delTopicsDeclaration(id);
				if (res.code == 200) {
					this.$message.success('删除成功！');
					this.getTopicsDeclarationList();
				} else {
					this.$message.error(res.data);
				}
			},
			// 获取课题申报列表
			async getTopicsDeclarationList() {
				const res = await getTopicsDeclarationList(this.form);
				if (res.code == 200) {
					console.log(res);
					this.topicList = res.data.records;
					this.total = res.data.total;
				} else {
					this.$message.error(res.data);
				}
			},
			// 搜索
			search() {
				this.form.pageNumber = 1;
				this.getTopicsDeclarationList();
			},
			// 跳转到课题申报页面
			async goTopicsDeclaration() {
				// 申报新课题判断
				if (this.userinfo) {
					// 判断一:普通教师才能申报
					// if (this.userinfo.roleId !== '') {
					// 	this.$alert('只有普通教师才能申报！', '提示', {
					// 		confirmButtonText: '确定',
					// 		type: 'warning',
					// 		callback: action => {}
					// 	});
					// 	return
					// }
					// 判断二:没有超过申报时间才能申报
					if (new Date(this.declareEndTime).getTime() <= Date.now()) {
						this.$alert('本次申报已截止！', '提示', {
							confirmButtonText: '确定',
							type: 'warning',
							callback: action => {}
						});
						return
					}
					// 判断三:同级别课题只能申报一个！
					const res = await topicDeclareBtnRightControl(this.projectData.id)
					if (res.code == 200) {
						if (res.data==1) {
							this.$alert('您当前已经申报过课题了，不允许重复申报！', '提示', {
								confirmButtonText: '确定',
								type: 'warning',
								callback: action => {}
							});
							return
						}else if (res.data==2) {
							this.$alert('您当前承担的课题还未结题，不允许申报新课题！', '提示', {
								confirmButtonText: '确定',
								type: 'warning',
								callback: action => {}
							});
							return
						}
					} else {
						this.$message.error(res.data)
					}
					// 
				}
				// 跳转到申报新课题的地方
				this.$router.push({
					path: '/backstage/projectApplicationProcess',
					query: {
						projectId: this.projectData.id,
						limit: this.projectData.limit
					}
				});
			},
			handleSizeChange(val) {
				this.form.pageSize = val;
				this.getTopicsDeclarationList();
			},

			handleCurrentChange(val) {
				this.form.pageNumber = val;
				this.getTopicsDeclarationList();
			}
		}
	};
</script>

<style scoped lang="scss">
	/* .card-body >>> .el-table .cell{
		line-height: 18px !important;
	} */
	.view {
		width: 1000px;
		height: 500px;
	}

	.comments-list {
		margin-top: 20px;
	}

	.file-list {
		width: 100%;
		display: flex;
		justify-content: center;
		padding-left: 0;
		list-style: none;

		.file-item {
			font-size: 24px;
			text-align: center;
			width: 50%;
			border-bottom: 2px solid #eee;
			cursor: pointer;
		}
	}

	.file-item.active {
		border-color: #00a2e8;
	}

	.btn_wrap {
		text-align: center;
	}
</style>
